import { render, staticRenderFns } from "./ma-code.vue?vue&type=template&id=00332b8a&"
import script from "./ma-code.vue?vue&type=script&lang=js&"
export * from "./ma-code.vue?vue&type=script&lang=js&"
import style0 from "./ma-code.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cinderellamaecuya/SP/peppermayo-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00332b8a')) {
      api.createRecord('00332b8a', component.options)
    } else {
      api.reload('00332b8a', component.options)
    }
    module.hot.accept("./ma-code.vue?vue&type=template&id=00332b8a&", function () {
      api.rerender('00332b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ma-code.vue"
export default component.exports